<div class="card">
  <table class="table">
    <tbody>
      <tr>
        <th scope="row">Username</th>
        <td>{{ profile?.username }}</td>
      </tr>
      <tr>
        <th scope="row">Email</th>
        <td>{{ profile?.email }}</td>
      </tr>
      <tr>
        <th scope="row">Display Name</th>
        <td>{{ profile?.name }}</td>
      </tr>
      <tr>
        <th scope="row">Role</th>
        <td>{{ profile?.role }}</td>
      </tr>
    </tbody>
  </table>
</div>
